<div class="m-portlet__body">
	<div class="m-portlet__head">
		<div class="m-portlet__body1 form-group m-form__group row">
			<!-- <div class="col-12 col-sm-8 col-xl-8 col-md-8">
<h4 class="m-portlet__head-text">

</h4>
</div> -->
			<div  class="col-12 col-sm-12 col-xl-12 col-md-12" style="text-align: right;">
				<div class="m-demo__preview m-demo__preview--btn col-12" style="text-align: right">
					<button  [disabled]="!showTable || attendenceMode === 'not applicable'" (click)="save()" type="button" class="btn btn-secondary">
						Save</button>
					<button [disabled]="!showTable || attendenceMode === 'not applicable'" (click)="submit()" type="button" class="btn btn-secondary">
						Submit</button>
					<button *ngIf="tableHeaderData && tableHeaderData.length > 0 " (click)="previewSheet()" type="button"
						class="btn btn-secondary">
						Preview Attendance Sheet</button>
				</div>
			</div>
		</div>
		<div class="form-group m-form__group row">
			<div class="col-md-3">
				<label class="col-form-label">
					<span style="font-weight:bold;">Attendance Mode: </span><span>{{attendenceMode}}</span>
				</label>
			</div>
		</div>


		<div class="form-group m-form__group row" [formGroup]="attendanceForm">

			<div class="col-md-2" [formGroup]="flterForm">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>Job Role (QP Code) </b>
					</label>
				</div>
				<div class="row">
					<div class="col-md-12">
						<!-- <select formControlName="jobRole"  class="form-control m-input disable" >
<option value="" selected disabled>Select Job Role</option>
<option *ngFor="let jobRole of currentBatchJobRoles" [value]=jobRole.qpCode>{{jobRole.jobRoleName}}</option>
</select> -->
						<input class="form-control m-input ng-untouched ng-pristine disable" placeholder="Job Role Not Found"
							name="candidateName" formControlName="jobRole">

					</div>
				</div>
			</div>
			<div class="col-md-7">
				<div class="row">

				</div>
				<div class="row" style="margin-left:16px">
					<div class="custom-file">
						<div class="row">
							<label class="col-form-label" style="margin-left: 20px">
								<b>Select Batch Date <span style="color:red;">*</span> </b>
							</label>
						</div>
						<div class="row">

							<div class="col-md-6" [formGroup]="flterForm">
								<select (change)="mirrorFuncForm()" formControlName="date" class="form-control m-input">
									<option value="" selected disabled>Select Batch Date</option>
									<option *ngFor="let date of dateArray" [disabled]="getDateValidationFuture(date)"
										[value]=date>{{date}}</option>
								</select>
							</div>
							
							<div class="col-md-6" [formGroup]="flterForm">
								<button (click)="clearForm();clearForm()" type="button" class="btn btn-secondary">
									Select</button>
							</div>
						</div>
						<br>
					</div>
				</div>
				
			</div>
			<div *ngIf="holidayDate" class="col-md-3" [formGroup]="flterForm">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>Holyday Date</b>
					</label>
				</div>
				<div class="row">
					<div class="col-md-12">
						<!-- <select formControlName="jobRole"  class="form-control m-input disable" >
<option value="" selected disabled>Select Job Role</option>
<option *ngFor="let jobRole of currentBatchJobRoles" [value]=jobRole.qpCode>{{jobRole.jobRoleName}}</option>
</select> -->
						<input class="form-control m-input ng-untouched ng-pristine disable" 
							name="candidateName" [(ngModel)]="holidayDate"  [ngModelOptions]="{standalone: true}">

					</div>
				</div>
			</div>
		</div>
		<!-- <div [formGroup]="orderForm">
<div formArrayName="items" *ngFor="let item of orderForm.get('items')['controls']; let i = index;">
<div class="form-group m-form__group row">
<div class="col-3">

<div [formGroupName]="i">
<input class="form-control m-input" placeholder="Enter Annual Turnover" name="candidateName" formControlName="candidateName">
<br>
</div>
<br>

</div>

</div>
</div>
</div> -->

		<div *ngIf="flterForm.value.date && this.flterForm.value.jobRole && showTable"
			class="form-group m-form__group row" [formGroup]="orderForm">

			<div class="col-md-3">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>Candidate Name </b>
					</label>
				</div>
				<div class="row" formArrayName="items"
					*ngFor="let item of orderForm.get('items')['controls']; let i = index;">
					<div class="col-md-12" [formGroupName]="i">
						<input class="form-control m-input ng-untouched ng-pristine disable"
							placeholder="Enter Annual Turnover" name="candidateName" formControlName="candidateName">
						<br>
						<!-- <input _ngcontent-c7=""  formcontrolname="candidateName" name="candidateName"  disabled="" ng-reflect-name="candidateName"> -->

					</div>

				</div>
			</div>
			<!--  -->

			<div class="col-md-3">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>Status </b>
					</label>
				</div>
				<div class="row" formArrayName="items"
					*ngFor="let item of orderForm.get('items')['controls']; let i = index;">
					<div class="col-md-12" [formGroupName]="i">
						<select [ngClass]="[holidayDate ? 'disable':'']" formControlName="status" class="form-control m-input">
							<option value="" selected disabled>Select Status</option>
							<option value="Completed">Completed</option>
							<option value="Dropout">Drop Out</option>
							<option value="Lateral">Lateral</option>
							<option value="N/A" id="hide" disabled *ngIf="item.controls.status.value === 'N/A' " >N/A</option>

						</select>
						<br>

					</div>

				</div>
			</div>
			<div class="col-md-3">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>Percentage </b>
					</label>
				</div>
				<div class="row" formArrayName="items"
					*ngFor="let item of orderForm.get('items')['controls']; let i = index;">
					<div class="col-md-12" [formGroupName]="i">
						<input class="form-control m-input"
							class="form-control m-input ng-untouched ng-pristine disable" placeholder="Enter Percentage"
							name="candidateName" formControlName="percentage">
						<br>

					</div>
				</div>
			</div>
			<div class="col-md-3">

				<div class="row">

					<label class="col-form-label" style="margin-left: 20px">
						<b>{{flterForm.value.date}} </b>
					</label>
				</div>
				<div class="row" formArrayName="items"
					*ngFor="let item of orderForm.get('items')['controls']; let i = index;">
					<div class="col-md-12" [formGroupName]="i">
						<select [ngClass]="[item.controls.status.value == 'Dropout' || holidayDate ? 'disable':'']"
							formControlName="attendanceStatus" class="form-control m-input">
							<option value="" selected disabled>Select Attendance</option>
							<option value="P">P</option>
							<option value="A">A</option>
							<option value="N/A" disabled  *ngIf="item.controls.status.value === 'N/A' " >N/A</option>

						</select>

						<br>
					</div>

				</div>
			</div>
		


		</div>

		<!-- <div class="row table-responsive" style="margin-top : 30px;">

<table  [formGroup]="orderForm"  class="notranslate table table-striped m-table">
<thead class="m-datatable__head">
<tr class="m-datatable__row">
<th><b>Sl.No</b></th>

</tr>
</thead>
<tbody>

<tr formArrayName="items" *ngFor="let item of orderForm.get('items')['controls']; let i = index;">
<div [formGroupName]="i">
<td>{{i+1}}</td>
<td>
<label>Candidate Name</label>
<input class="form-control m-input" [disabled]="true" name="candidateName" formControlName="candidateName">
</td>
<td>
<label>{{dates}}</label>

<input class="form-control m-input" placeholder="Enter P/A" name="candidateName" formControlName="attendanceStatus">
</td>

</div>
</tr>
</tbody>
</table>

</div> -->
		<div class="col-md-12" style="margin-top:5%">
			<div class="row">
				<label class="col-form-label" style="margin-left: 20px;font-size: 22px">
					Upload Other Supporting Documents
				</label>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="row">
						<div class="input-group col-md-12">
							<app-upload-file [isMultiSelect]="false"
								[formValue]="attendanceForm.get('supportingDocuments').get('supportingDocs')"
								info="pdf,doc,jpeg,jpg,png,xls,xlsx" fileType="file" (valueChange)="setFileUploaded()">
							</app-upload-file>
							<app-form-control-messages
								[control]="attendanceForm.get('supportingDocuments').get('supportingDocs')"
								[name]="'file'"></app-form-control-messages>

						</div>
						<div class="input-group col-md-12">
							<button (click)="submitDocument()" type="button" class="btn btn-secondary">
								Submit Document</button>
						</div>
						<div class="input-group col-md-12">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12" style="margin-top:5%" *ngIf="supportingDoc">
			<div class="row">
				<label class="col-form-label" style="margin-left: 20px;font-size: 22px">
					Uploaded Supporting Documents
				</label>
			</div>
			<div class="row">
				<div class="col-md-6">
					<table class="notranslate table table-striped m-table">
						<thead class="m-datatable__head">
							<tr class="m-datatable__row">
								<th>Sl.No</th>
								<th>
									Name of Document
								</th>
								<!-- <th>Action</th> -->
							</tr>
						</thead>
						<tbody>
							<!-- <tr *ngFor="let data of searchedData; let i = index;"> -->
							<tr>
								<td>{{1}}</td>
								<td style="color:#ef7e22;text-decoration:underline;cursor:pointer"
									(click)="privewDocument(supportingDoc)">View Document</td>
								<!-- <td style="color:red;cursor: pointer;" (click)="removeFile(1)">Delete</td> -->
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="att-sheet" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg xl-model" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">
						Attendence Sheet
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeModal>
						<span aria-hidden="true">
							&times;
						</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="col-md-7">
						<div class="row">

						</div>
						<div class="row" style="margin-left:16px">
							<!-- <div class="custom-file">
								<div class="row">
									<label class="col-form-label" style="margin-left: 20px">
										<b>Select Months</b>
									</label>
								</div>
								<div class="row">

									<div class="col-md-6" [formGroup]="monthFilter">
										<select (change)="filterAttendenceByMonth()" formControlName="month"
											class="form-control m-input">
											<option value="" selected disabled>Please select months</option>
											<option *ngFor="let month of monthArray" [value]=month.value>{{month.name}}
											</option>
										</select>
									</div>
									<div class="col-md-3">
										<button class="btn  btn-primary" (click)="clearFilter()">Reset</button>
									</div>

								</div>
								<br>
							</div> -->
						</div>
					</div>
					<br>
					<form class="m-form m-form--fit m-form--label-align-right">
						<div class="m-portlet__body">

							<div class="row table-responsive" style="margin-top : 30px;">
								<table class="notranslate table table-striped m-table">
									<thead *ngIf="batchAttendenceArray.length > 0" class="m-datatable__head">
										<tr class="m-datatable__row">
											<th><b>Sl.No</b></th>
											<th>
												<b>Name of Applicants</b>
											</th>
											<th>
												<b>Status</b>
											</th>
											<th>
												<b>Percentage</b>
											</th>
											<!-- <div *ngIf="batchAttendenceArray.length > 0"> -->
											<th *ngFor="let date of batchAttendenceArray[0].attendence;">
												<b>{{date.date | date}}</b>
											</th>
											<!-- </div> -->

										</tr>
									</thead>
									<thead *ngIf="batchAttendenceArray.length == 0" class="m-datatable__head">
										<tr class="m-datatable__row">
											<th><b>Sl.No</b></th>
											<th>
												<b>Name of Applicants</b>
											</th>
											<th>
												<b>Status</b>
											</th>
											<th>
												<b>Percentage</b>
											</th>
										</tr>
									</thead>
									<tbody>
										<!-- <tr *ngFor="let data of searchedData; let i = index;"> -->
										<tr *ngFor="let applicant of batchAttendenceArray; let i=index;">
											<td>{{i+1}}</td>
											<td>{{applicant.candiateName?applicant.candiateName : 'N/A'}}</td>
											<td><span
													[style.color]="statusColor[applicant.status?applicant.status: '']"><b>{{applicant.status?applicant.status: 'N/A'}}</b></span>
											</td>
											<td>{{applicant.percentage?applicant.percentage: ''}}</td>
											<td *ngFor="let attendace of applicant.attendence; let j=index;">
												<span
													[style.color]="statusColor[attendace.attendenceStatus?attendace.attendenceStatus: '-']">
													<b>{{attendace.attendenceStatus?attendace.attendenceStatus:"-"}}</b></span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

						</div>
					</form>
				</div>
				<!-- <div class="modal-footer">

<button type="button" class="btn btn-next" [disabled]="!appealActionForm.valid" (click)="onAppealSubmit()">
Submit
</button>
<button type="button" class="btn  btn-cancel" data-dismiss="modal">
Cancel
</button>
</div> -->
			</div>

		</div>
	</div>
	</div>

